import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

// 根据环境动态选择路由历史模式
// singlefile 模式使用 hash history，其它模式使用 web history
const isSingleFileMode = import.meta.env.MODE === 'singlefile'
const historyMode = isSingleFileMode
  ? createWebHashHistory(import.meta.env.VITE_BASE_URL)
  : createWebHistory(import.meta.env.VITE_BASE_URL)

const router = createRouter({
  history: historyMode,
  routes: [
    {
      path: '/',
      name: 'keyboard',
      component: () => import('../views/pressKey.vue'),
      meta: { requiresDevice: true }
    },
    {
      path: '/auth',
      name: 'auth',
      component: () => import('../views/auth.vue'),
      meta: { requiresDevice: false }
    },
    {
      path: '/configuration',
      name: 'configuration',
      component: () => import('../views/configuration.vue'),
      meta: { requiresDevice: true }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/AboutView.vue'),
      meta: { requiresDevice: true }
    },
    {
      path: '/keyboard',
      redirect: '/'
    }
  ],
})

// 路由守卫：检查设备连接状态
router.beforeEach(async (to, from, next) => {
  // 获取 device store
  const { useDeviceStore } = await import('@/stores/device.js')
  const deviceStore = useDeviceStore()

  // 检查设备是否已连接
  const isDeviceConnected = deviceStore.isOpened &&
    deviceStore.deviceVendorId !== null &&
    deviceStore.deviceProductId !== null

  console.log(`[Router Guard] 导航到 ${to.path}`)
  console.log(`[Router Guard] 设备已连接: ${isDeviceConnected}`)

  // 获取路由的设备连接要求
  const requiresDevice = to.meta.requiresDevice ?? true

  console.log(`[Router Guard] 需要设备: ${requiresDevice}`)

  // 如果目标页面需要设备但设备未连接
  if (requiresDevice && !isDeviceConnected) {
    console.warn('[Router Guard] 设备未连接，重定向到 auth 页面')
    next('/auth')
    return
  }

  // 如果用户在 auth 页面且设备已连接，可以选择跳转到 keyboard 页面
  if (to.path === '/auth' && isDeviceConnected) {
    console.log('[Router Guard] 设备已连接，可导航到 keyboard 页面')
    // 可选：自动跳转到 keyboard
    // next('/')
    // return
    // 或者允许用户选择停留在 auth 或跳转
  }

  next()
})

export default router
